
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-print");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/print/index.js
// module id = NQkC
// module chunks = 11